'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import A from "../defs/Yarn.es.js";
const r = a.forwardRef((a$1, e) => /* @__PURE__ */ a.createElement(p, { ref: e, ...a$1, weights: A }));
r.displayName = "YarnIcon";
const s = r;
export {
  s as Yarn,
  r as YarnIcon
};
